<template>
  <div class="columns is-vcentered is-multiline is-tablet mt-4">
    <div class="column is-flex is-align-items-center is-full is-one-quarter-widescreen">
      <small class="has-text-grey is-abbr-like" :title="pagination.total">Totale: {{ pagination.total }}</small>
      <div class="is-flex is-align-items-center ml-4">
        <div class="select is-small mr-1">
          <select style="max-width: 70px;" @change="setPageSize($event)">
            <option>30</option>
            <option>100</option>
            <option>500</option>
          </select>
        </div>
        <div>
          <small class="has-text-grey is-abbr-like">risultati per pagina</small>
        </div>
      </div>
    </div>
    <div class="column is-full is-half-widescreen is-flex is-justify-content-center">
      <nav class="pagination is-right" role="navigation" v-show="pagination.pages !== false">
        <ul class="pagination-list">
          <template v-for="(page) in pagination.pages">
            <li v-if="pagination.selected > 3 && page == 3">
              <span class="pagination-ellipsis">&hellip;</span>
            </li>
            <li v-if="Math.abs(page - pagination.selected) < 2 || page == pagination.pages || page == 1">
              <a class="pagination-link" :class="{'is-current': (page == pagination.selected)}" @click="setPageNumber(page)">{{page}}</a>
            </li>
            <li v-if="pagination.selected < (pagination.pages - 2) && page == (pagination.pages - 2)">
              <span class="pagination-ellipsis">&hellip;</span>
            </li>
          </template>
        </ul>
      </nav>
    </div>
    <div class="column is-one-quarter p-0"></div>
  </div>
</template>

<script>
export default {
  props: ['pagination'],

  emits: ['change'],

  data() {
    return {
      pageNumber: 1,
      pageSize: 30
    }
  },

  methods: {
    onChange() {
      this.$emit('change', {
        page: this.pageNumber,
        size: this.pageSize
      })
    },

    setPageNumber(page) {
      this.pageNumber = page

      this.onChange()
    },

    setPageSize(event) {
      const size = event.target.value

      this.pageSize = size

      this.onChange()
    }
  }
}
</script>